<div class="p-16 m-16">
  <p>collect works!</p>
</div>
<div class="p-16 m-16">
  <p>collect works!</p>
</div>
